
import React, { useState, useEffect } from 'react';
import { Tab } from '../types';
import { NAV_ITEMS } from '../constants';

interface NavbarProps {
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
}

export const Navbar: React.FC<NavbarProps> = ({ activeTab, setActiveTab }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (tab: Tab) => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 hidden md:block ${
        isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo Area: 修改为 items-center 居中对齐 */}
        <div 
          className="flex flex-col items-center cursor-pointer group" 
          onClick={() => handleNavClick('home')}
        >
          <h1 className="font-serif text-2xl md:text-3xl font-black text-stone-800 tracking-wide group-hover:text-sage-700 transition-colors">
            言屿心理咨询室
          </h1>
          <p className="text-[0.5rem] md:text-[0.55rem] uppercase tracking-[0.12em] text-sage-500 font-medium mt-1 group-hover:text-rose-500 transition-colors">
            YANYU PSYCHOLOGICAL COUNSELING STUDIO
          </p>
        </div>

        {/* Desktop Nav */}
        <div className="flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className={`text-sm tracking-widest transition-all duration-300 pb-1 border-b-2 ${
                activeTab === item.id 
                  ? 'text-stone-900 border-sage-400 font-bold' 
                  : 'text-stone-600 border-transparent hover:text-stone-900 hover:border-rose-300'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};
